export function blockEl() {
  if( arguments.length > 0 ){
    [...arguments].forEach(el => {
      if(el) {
        el.classList.add('element-blocked');
      }
    })
  }
}

export function unblockEl() {
  if( arguments.length > 0 ){
    [...arguments].forEach(el => {
      if(el) {
        el.classList.remove('element-blocked');
      }
    })
  }
}
